<script setup>
import { computed } from 'vue';
import { useSubscriptionStore } from '@organisms/ubiq-administration/store/subscriptions';
import { getCompleteReadableDate } from '@tools/date';
import { PhoneNumber } from '@tools/phoneNumber';
import { URL_ADDRESS_PAGE, URL_OFFER_VIEW_ENDPOINT } from '@tools/routes/routes';
import { trans } from '../../../../_00_elements/translation';
import SubscriptionDetailsSection from './SubscriptionDetailsSection.vue';
import SubscriptionDetailsValue from './SubscriptionDetailsValue.vue';
import { currency } from '../../../../_00_elements/number-formatter';
import SubscriptionStatusTag from './SubscriptionStatusTag.vue';

const subscription = computed(() => useSubscriptionStore().selectedSubscriptionData);
const client = computed(() => subscription.value.client);
const startDate = computed(() => subscription.value.start_date.iso ?? subscription.value.start_date.date);
const endDate = computed(() => {
  if (!subscription.value.end_date) {
    return null;
  }

  return subscription.value.end_date.iso ?? subscription.value.end_date.date;
});
</script>

<template>
  <SubscriptionDetailsSection>
    <template #details>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.status')">
        <SubscriptionStatusTag v-if="subscription.status" :status="subscription.status" />
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.amount_ht')">
        {{ currency(subscription.amount / 100) }}
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.start_date')">
        {{ getCompleteReadableDate(startDate) }}
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.end_date')">
        <span v-if="endDate">{{ getCompleteReadableDate(endDate) }}</span>
        <span v-else>-</span>
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.buyer.organization_name')" :value="client.legal_name" />
      <SubscriptionDetailsValue :label="trans('gestion.subscription.buyer.contact')">
        <template v-if="subscription.client_name">
          {{ subscription.client_name }}<br>
        </template>
        <template v-if="client.email">
          {{ client.email }}<br>
        </template>
        <template v-if="client.phone_number">
          {{ new PhoneNumber(client.phone_number).printFormattedNational }}
        </template>
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.buyer.address')">
        {{ client.street_and_number }}<br>
        <template v-if="client.additional_info">
          {{ client.additional_info }}<br>
        </template>
        {{ client.zip_code }} {{ client.city }}
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.office_space')" class="subscription-details-section__offers">
        <a :href="`${URL_ADDRESS_PAGE}/${subscription.address.id}`">
          {{ subscription.address.name }}
        </a>
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.offices')" class="subscription-details-section__offers">
        <div v-for="(office, index) in subscription.office_offers" :key="index">
          <a :href="`${URL_OFFER_VIEW_ENDPOINT}/${office.hash_id}`">{{ office.name }}</a>
          {{ index < (subscription.office_offers.length - 1) ? trans('global.plus') : '' }}
        </div>
      </SubscriptionDetailsValue>
    </template>
  </SubscriptionDetailsSection>
</template>
